<ng-container matColumnDef="calibre">
  <mat-header-cell [crud-column-header]="columns.column('calibre')" *matHeaderCellDef mat-sort-header
    cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-tiny"
    i18n="@@type.Firearm.calibre">
    Calibre
  </mat-header-cell>
  <mat-cell class="search-column-tiny" *matCellDef="let element" [ngClass]="cellClass(element, 'calibre')">
    {{element.calibre | refDecode:'FIREARM_CALIBRE' | async}}
  </mat-cell>
</ng-container>

<ng-container matColumnDef="firearmType">
  <mat-header-cell [crud-column-header]="columns.column('firearmType')" *matHeaderCellDef mat-sort-header
    cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-verysmall"
    i18n="@@type.Firearm.firearmType">
    Firearm Type
  </mat-header-cell>
  <mat-cell class="search-column-verysmall" *matCellDef="let element" [ngClass]="cellClass(element, 'firearmType')">
    {{element.firearmType | refDecode:'FIREARM_TYPE' | async}}
  </mat-cell>
</ng-container>


<ng-container matColumnDef="currentAssignmentEmail">
  <mat-header-cell [crud-column-header]="columns.column('currentAssignmentEmail')" *matHeaderCellDef 
    cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-medium" i18n="@@type.Firearm.currentAssignmentEmail">
      Current Assignment Email 
    </mat-header-cell>
  <mat-cell class="search-column-medium" *matCellDef="let element" [ngClass]="cellClass(element, 'currentAssignmentEmail')">
    {{element.currentAssignmentEmail}}
  </mat-cell>
</ng-container>  

<ng-container matColumnDef="currentAssignmentFirearmAssignmentType">
  <mat-header-cell [crud-column-header]="columns.column('currentAssignmentFirearmAssignmentType')" *matHeaderCellDef 
    cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-verysmall" i18n="@@type.Firearm.currentAssignmentFirearmAssignmentType">
      Current Assignment Type 
    </mat-header-cell>
  <mat-cell class="search-column-verysmall" *matCellDef="let element" [ngClass]="cellClass(element, 'currentAssignmentFirearmAssignmentType')">
    {{element.currentAssignmentFirearmAssignmentType | refDecode:'FIREARM_ASSIGNMENT_TYPE' | async}}
  </mat-cell>
</ng-container>  

<ng-container matColumnDef="currentlyAssigned">
  <mat-header-cell [crud-column-header]="columns.column('currentlyAssigned')" *matHeaderCellDef 
    cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.Firearm.currentlyAssigned">
      Currently Assigned 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'currentlyAssigned')">
    <mat-icon *ngIf="element.currentlyAssigned">check_box</mat-icon><mat-icon *ngIf="!element.currentlyAssigned">check_box_outline_blank</mat-icon>
  </mat-cell>
</ng-container>  

<ng-container matColumnDef="personalFirearm">
  <mat-header-cell [crud-column-header]="columns.column('personalFirearm')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-verysmall" i18n="@@type.Firearm.personal">
      Personal
    </mat-header-cell>
  <mat-cell class="search-column-verysmall" *matCellDef="let element">
    <mat-icon *ngIf="element.personalFirearm">check_box</mat-icon><mat-icon *ngIf="!element.personalFirearm">check_box_outline_blank</mat-icon>
  </mat-cell>
</ng-container> 

<ng-container matColumnDef="lifecycleState">
  <mat-header-cell [crud-column-header]="columns.column('lifecycleState')" *matHeaderCellDef 
    cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.Firearm.lifecycleState">
      Lifecycle State 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'lifecycleState')">
    {{element.lifecycleState | refDecode:'FIREARM_LIFECYCLE_STATE' | async}}
  </mat-cell>
</ng-container>  

<ng-container matColumnDef="suspended">
  <mat-header-cell [crud-column-header]="columns.column('suspended')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.Firearm.suspended">
      Suspended 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'suspended')">
    <mat-icon *ngIf="element.suspended">check_box</mat-icon><mat-icon *ngIf="!element.suspended">check_box_outline_blank</mat-icon>
  </mat-cell>
</ng-container>  

<ng-container matColumnDef="currentlyAssignable">
  <mat-header-cell [crud-column-header]="columns.column('currentlyAssignable')" *matHeaderCellDef 
    cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.Firearm.currentlyAssignable">
      Currently Assignable 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'currentlyAssignable')">
    <mat-icon *ngIf="element.currentlyAssignable">check_box</mat-icon><mat-icon *ngIf="!element.currentlyAssignable">check_box_outline_blank</mat-icon>
  </mat-cell>
</ng-container>  

<ng-container matColumnDef="poolFirearm">
  <mat-header-cell [crud-column-header]="columns.column('poolFirearm')" *matHeaderCellDef 
    cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-tiny" i18n="@@type.Firearm.poolFirearm">
      Pool 
    </mat-header-cell>
  <mat-cell class="search-column-tiny" *matCellDef="let element">
    <mat-icon *ngIf="element.poolFirearm">check_box</mat-icon><mat-icon *ngIf="!element.poolFirearm">check_box_outline_blank</mat-icon>
  </mat-cell>
</ng-container>  
